var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0604 11.9999L21.5304 3.52994C21.8204 3.23994 21.8204 2.75994 21.5304 2.46994C21.2404 2.17994 20.7604 2.17994 20.4704 2.46994L12.0004 10.9399L3.53043 2.46994C3.24043 2.17994 2.76043 2.17994 2.47043 2.46994C2.18043 2.75994 2.18043 3.23994 2.47043 3.52994L10.9404 11.9999L2.47043 20.4699C2.18043 20.7599 2.18043 21.2399 2.47043 21.5299C2.76043 21.8199 3.24043 21.8199 3.53043 21.5299L12.0004 13.0599L20.4704 21.5299C20.6204 21.6799 20.8104 21.7499 21.0004 21.7499C21.1904 21.7499 21.3804 21.6799 21.5304 21.5299C21.8204 21.2399 21.8204 20.7599 21.5304 20.4699L13.0604 11.9999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.a15b1b77fb3029e80314ecaa8aebe849.svg";
export { ForwardRef as ReactComponent };